export default "__VITE_ASSET__DQc5P3IX__"